import { string } from 'prop-types';
import React from 'react';

/**
 * returns passed HTML wrapped in a <div>, with an optional class.
 *
 * POSSIBLE ENHANCEMENTS:
 * - allow for the wrapping element to be specified
 *
 */
function Html(props) {
  const { html, className } = props;

  const divProps = {
    dangerouslySetInnerHTML: { __html: (html || '').trim() }
  };

  if (className) {
    divProps.className = className;
  }

  return <div {...divProps} />;
}

Html.propTypes = {
  html: string.isRequired,
  className: string
};

Html.defaultProps = {
  className: undefined
};

export default Html;
